class SaveDialogController {
  constructor($rootScope) {
    "ngInject";
    this.$rootScope = $rootScope;
    this.name = 'saveDialog';
    this.visible = false;
    /**
     * Function to be called when the content gets edited
     * @param  {string} $routeChangeStart     the event
     * @param  {object} event                 the event object
     * @return {void}
     */
    $rootScope.$on('INPUT', (event, data) => {
        this.visible = true;
    });
  }

  save() {
    this.$rootScope.$broadcast('SAVE');
    this.visible = false;
  }

  cancel() {
    this.$rootScope.$broadcast('CANCEL');
    this.visible = false;
  }
}

export default SaveDialogController;



// WEBPACK FOOTER //
// ./client/app/common/saveDialog/saveDialog.controller.js